import React from 'react';
import PropTypes from 'prop-types';

import { lastEligibilityQuestion, parseFullName } from 'utils/helpers';
import { texts } from 'utils/languages/fr';

import {
    indentedInputsSx,
    inputSx,
    labelSx,
    multilineSx,
    option2LabelSx,
    option3LabelSx,
    subLabelSx,
    textareaSx,
} from './eligibilityStyles';
import { DocumentUpload } from 'containers/tunnel/common';
import { CustomSelect, CustomTextField, ErrorMessage, RadioLabel } from 'components';
import { Box, RadioGroup, MenuItem, Typography } from '@mui/material';

const EligibilityForm = props => {
    const {
        form,
        messages,
        errors,
        handleRadioButtons,
        handleChange,
        adminList,
        durations,
        isSLP,
        isFPS,
        sgpName,
        removeExemptionConditionsProof,
        handleExemptionConditionsProofChange,
    } = props;

    const {
        investorQualification,
        subscriptionRequestMotivation,
        internalContactUser,
        nameOfEntity,
        nameOfFIA,
        durationOfHolding,
        exemptionConditionsProof,
    } = form;

    return (
        <React.Fragment>
            <Box sx={multilineSx}>
                <Box display="flex" alignItems="baseline" justifyContent="space-between">
                    <RadioLabel
                        sx={labelSx}
                        label={messages['step34.question_1.label']}
                        value="step34.question_1.label"
                    />
                </Box>
            </Box>
            {!isSLP && (
                <Box sx={multilineSx}>
                    <Box display="flex" justifyContent="space-between" alignItems="baseline">
                        <RadioLabel
                            sx={labelSx}
                            value="step34.question_2.label"
                            label={
                                <span>
                                    {messages['step34.question_2.label']?.replace(
                                        '30 000',
                                        `30${'\u00A0'}000`
                                    )}
                                </span>
                            }
                            checked={
                                investorQualification?.includes('step34.question_2') ||
                                investorQualification?.includes('step34_fpci_pm_real.question_18')
                            }
                        />
                    </Box>
                    {(investorQualification?.includes('step34.question_2') ||
                        investorQualification?.includes('step34_fpci_pm_real.question_18')) && (
                        <Box
                            mt={2}
                            ml={7}
                            display="flex"
                            alignItems="baseline"
                            flexDirection="column"
                            justifyContent="space-between"
                        >
                            <RadioGroup
                                value={investorQualification}
                                name="investorQualification"
                                onChange={handleRadioButtons('investorQualification')}
                            >
                                <RadioLabel
                                    sx={subLabelSx}
                                    label={messages['step34.question_2.option_1']}
                                    value="step34.question_2.option_1"
                                />
                                {investorQualification.includes('option_1') && (
                                    <CustomTextField
                                        rows={4}
                                        multiline
                                        sx={textareaSx}
                                        formControlProps={{
                                            sx: theme => ({
                                                ...inputSx(theme),
                                                ...indentedInputsSx,
                                            }),
                                        }}
                                        value={subscriptionRequestMotivation}
                                        label={texts.VOTRE_INTERVANTION}
                                        onChange={handleChange('subscriptionRequestMotivation')}
                                        error={errors.subscriptionRequestMotivation}
                                    />
                                )}
                                <RadioLabel
                                    sx={subLabelSx}
                                    label={messages['step34.question_2.option_2']}
                                    value="step34.question_2.option_2"
                                />
                                {investorQualification.includes('option_2') && (
                                    <CustomSelect
                                        formControlProps={{
                                            sx: theme => ({
                                                ...inputSx(theme),
                                                ...indentedInputsSx,
                                                ...option2LabelSx,
                                            }),
                                        }}
                                        label={texts.INDIQUER_LE_NOM(sgpName)}
                                        value={internalContactUser}
                                        onChange={handleChange('internalContactUser')}
                                    >
                                        {adminList.map(admin => (
                                            <MenuItem key={admin.id} value={admin.id}>
                                                {parseFullName(admin)}
                                            </MenuItem>
                                        ))}
                                    </CustomSelect>
                                )}
                                <RadioLabel
                                    sx={subLabelSx}
                                    label={messages['step34.question_2.option_3']}
                                    value="step34.question_2.option_3"
                                />
                                {investorQualification.includes('option_3') && (
                                    <React.Fragment>
                                        <Typography
                                            sx={option3LabelSx}
                                            variant="body1"
                                            color="textSecondary"
                                        >
                                            {texts.SEIN_DE_LAQUELL}
                                        </Typography>
                                        <CustomTextField
                                            label={texts.NOM_DE_ENTITE}
                                            value={nameOfEntity}
                                            onChange={handleChange('nameOfEntity')}
                                            formControlProps={{
                                                sx: theme => ({
                                                    ...inputSx(theme),
                                                    ...indentedInputsSx,
                                                }),
                                            }}
                                            error={errors.nameOfEntity}
                                        />
                                        <CustomTextField
                                            label={texts.NOM_DU_FIA}
                                            value={nameOfFIA}
                                            onChange={handleChange('nameOfFIA')}
                                            formControlProps={{
                                                sx: theme => ({
                                                    ...inputSx(theme),
                                                    ...indentedInputsSx,
                                                }),
                                            }}
                                            error={errors.nameOfFIA}
                                        />
                                        <CustomSelect
                                            label={texts.DUREE_DE_DETENTION}
                                            value={durationOfHolding}
                                            onChange={handleChange('durationOfHolding')}
                                            controlSx={theme => ({
                                                ...inputSx(theme),
                                                ...indentedInputsSx,
                                            })}
                                            error={errors.durationOfHolding}
                                        >
                                            {durations?.map(duration => (
                                                <MenuItem key={duration} value={duration}>
                                                    {messages[duration]}
                                                </MenuItem>
                                            ))}
                                        </CustomSelect>
                                    </React.Fragment>
                                )}
                            </RadioGroup>
                            {errors.investorQualification && (
                                <ErrorMessage
                                    message={errors.investorQualification}
                                    sx={indentedInputsSx}
                                />
                            )}
                        </Box>
                    )}
                    {(investorQualification?.includes('step34.question_2') ||
                        investorQualification?.includes('step34_fpci_pm_real.question_18')) && (
                        <DocumentUpload
                            id="exemption-condition-proof-documents"
                            isTableCell
                            label={messages['step34.question_2.exemption_conditions_proof']}
                            selectedFiles={exemptionConditionsProof}
                            handleFileChange={handleExemptionConditionsProofChange}
                            removeFile={removeExemptionConditionsProof}
                        />
                    )}
                    {errors.exemptionConditionsProof && (
                        <ErrorMessage message={errors.exemptionConditionsProof} />
                    )}
                </Box>
            )}
            <Box sx={multilineSx}>
                <Box display="flex" alignItems="baseline" justifyContent="space-between">
                    <RadioLabel
                        sx={labelSx}
                        label={messages['step34.question_3.label']}
                        value="step34.question_3.label"
                    />
                </Box>
            </Box>
            <Box sx={multilineSx}>
                <Box display="flex" alignItems="baseline" justifyContent="space-between">
                    <RadioLabel
                        sx={labelSx}
                        label={lastEligibilityQuestion(
                            isSLP,
                            isFPS,
                            messages['step34.question_4.label']
                        )}
                        value="step34.question_4.label"
                    />
                </Box>
            </Box>
        </React.Fragment>
    );
};

EligibilityForm.propTypes = {
    form: PropTypes.object,
    messages: PropTypes.object,
    errors: PropTypes.object,
    handleRadioButtons: PropTypes.func,
    handleChange: PropTypes.func,
    adminList: PropTypes.array,
    durations: PropTypes.array,
    isSLP: PropTypes.bool,
    isFPS: PropTypes.bool,
    sgpName: PropTypes.string,
    removeExemptionConditionsProof: PropTypes.func,
    handleExemptionConditionsProofChange: PropTypes.func,
};

export default EligibilityForm;
